import { fileUrl } from "@/lib/api";

const FIELDS = ["power", "participation", "attacks", "defenses", "repairs", "heals"];
const fmt = (v) => (v === null || v === undefined ? "—" : Number(v).toLocaleString());

export const SubmissionCard = ({ s, onAct }) => {
  const rows = FIELDS.filter((f) => s.stats?.[f] !== null && s.stats?.[f] !== undefined);
  return (
    <div className="lg-sub" data-testid={`inbox-item-${s.id}`}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
        <strong>{s.playerName}</strong>
        <span style={{ fontSize: 12, color: "var(--muted)" }}>{new Date(s.submittedAt).toLocaleString()} · {s.status}</span>
      </div>
      {rows.length > 0 && (
        <table>
          <thead><tr><th>Stat</th><th>Now</th><th>Submitted</th></tr></thead>
          <tbody>{rows.map((f) => {
            const cur = s.current?.[f], nv = s.stats[f];
            const cls = cur == null ? "" : nv > cur ? "lg-up" : nv < cur ? "lg-down" : "";
            return <tr key={f}><td style={{ textTransform: "capitalize" }}>{f}</td><td>{fmt(cur)}</td><td className={cls}>{fmt(nv)}</td></tr>;
          })}</tbody>
        </table>
      )}
      {s.note && <p style={{ fontSize: 13, margin: "6px 0" }}>“{s.note}”</p>}
      {s.images?.length > 0 && (
        <div className="lg-photos" style={{ margin: "8px 0" }}>
          {s.images.map((u) => <a key={u} className="lg-thumb" href={fileUrl(u)} target="_blank" rel="noreferrer"><img src={fileUrl(u)} alt="Submitted screenshot" /></a>)}
        </div>
      )}
      {s.status === "pending" && (
        <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <button className="lg-btn sm" disabled={!rows.length} onClick={() => onAct(s.id, "apply")} data-testid={`inbox-apply-${s.id}`}>Apply to roster</button>
          <button className="lg-btn sm danger" onClick={() => onAct(s.id, "dismiss")} data-testid={`inbox-dismiss-${s.id}`}>Dismiss</button>
        </div>
      )}
    </div>
  );
};
